import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutofillDirective } from './autofill.directive';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
      AutofillDirective
    ],
    exports: [
      AutofillDirective
    ]
})
export class AutofillModule {}
